import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import ResumeAnalyzer from "./pages/ResumeAnalyzer";
import SkillGapPage from "./pages/SkillGapPage";
import MockInterview from "./pages/MockInterview";
import InterviewSession from "./pages/InterviewSession";
import InterviewReview from "./pages/InterviewReview";
import Leaderboard from "./pages/Leaderboard";
import Badges from "./pages/Badges";
import Pricing from "./pages/Pricing";
import Profile from "./pages/Profile";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import GrowthDashboard from "./pages/GrowthDashboard";
import OrgDashboard from "./pages/OrgDashboard";
import UpgradeModal from "./components/UpgradeModal";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => { document.title = "SkillGap Pilot — AI-powered career intelligence"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pricing" element={<Pricing publicView />} />
          <Route path="/app/pricing/success" element={
            <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
          } />
          <Route path="/app/pricing/failed" element={
            <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
          } />
          <Route path="/app" element={
            <ProtectedRoute><AppLayout /></ProtectedRoute>
          }>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="resume" element={<ResumeAnalyzer />} />
            <Route path="skillgap" element={<SkillGapPage />} />
            <Route path="interview" element={<MockInterview />} />
            <Route path="interview/:id" element={<InterviewSession />} />
            <Route path="interview/:id/review" element={<InterviewReview />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="badges" element={<Badges />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="profile" element={<Profile />} />
            <Route path="admin" element={<AdminDashboard />} />
            <Route path="admin/growth" element={<GrowthDashboard />} />
            <Route path="org/dashboard" element={<OrgDashboard />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <UpgradeModal />
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
